module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('title-component', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('popular-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('progress-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('abnormal-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('product-analysis-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), (_vm.showTc) ? _c('tc-component', {
    attrs: {
      "bizCode": _vm.bizCode,
      "productId": _vm.productId,
      "productName": _vm.productName,
      "startDateParams": _vm.startDate,
      "endDateParams": _vm.endDate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7b7890c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/Main.vue
// module id = 697
// module chunks = 0